import { defineStore, storeToRefs } from 'pinia'
import { useBusinessStore } from './business'
import { useSessionStore } from './session'
import { useUiStore } from './ui'

export const useAppStore = defineStore('app', () => {
  const sessionStore = useSessionStore()
  const uiStore = useUiStore()
  const businessStore = useBusinessStore()

  return {
    ...storeToRefs(sessionStore),
    ...storeToRefs(uiStore),
    ...storeToRefs(businessStore),
    setToken: (...args) => sessionStore.setToken(...args),
    reqUserInfo: (...args) => sessionStore.reqUserInfo(...args),
    openModal: (...args) => uiStore.openModal(...args),
    closeModal: (...args) => uiStore.closeModal(...args),
    setCurrentPage: (...args) => uiStore.setCurrentPage(...args),
    syncPageAnalytics: (...args) => uiStore.syncPageAnalytics(...args),
    setConfig: (...args) => businessStore.setConfig(...args),
    reqTeamsList: (...args) => businessStore.reqTeamsList(...args),
    reqMatchSimpleSeasons: (...args) => businessStore.reqMatchSimpleSeasons(...args),
    reqRedDotState: (...args) => businessStore.reqRedDotState(...args),
    getGoodsList: (...args) => businessStore.getGoodsList(...args)
  }
})
